<template>
    <v-layout row wrap>
        <v-flex xs12 lg10 offset-lg1>
            <v-card>
                <v-card-title class="search">
                    <v-btn icon class="ma-0">
                        <v-icon>search</v-icon>
                    </v-btn>
                    <label class="grey--text lighten-1" @click="openSearch">{{ filterPlaceholder }}</label>
                    <slot name="beforeReloadButton"></slot>
                    <v-tooltip left>
                        <v-btn v-if="this.refresh != null" icon class="ma-0" @click="reload" slot="activator">
                            <v-icon @click="reload">refresh</v-icon>
                        </v-btn>
                        <span>{{$t('tooltip.refresh')}}</span>
                    </v-tooltip>
                    <slot name="afterReloadButton"></slot>
                </v-card-title>
                <v-card-title v-if="searching" class="search-input">
                    <v-btn icon class="ma-0">
                        <v-icon>search</v-icon>
                    </v-btn>
                    <input type="text" :placeholder="filterPlaceholder" v-model="filter" @keyup.enter="closeSearch" @keyup.esc="cancelSearch" v-on-click-outside="closeSearch" v-focus/>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-data-table v-bind:headers="headers" :items="items" :rows-per-page-text="$t('label.pagination')" :loading="loading" :rows-per-page-items="rowsPerPageItems" :no-data-text="$t('message.warning.noData')" :pagination.sync="customPagination">
                        <template slot="items" slot-scope="{item}">
                            <slot name="items" :item="item"></slot>
                        </template>
                        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                            {{ pageStart }}-{{ pageStop }} of {{items.length}}
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import utilities from '@/helpers/utilities';
import constants from '@/helpers/constants';
import i18n from '@/i18n';

export default {
    props: {
        headers: {
            type: Array,
            required: true,
        },
        search: {
            type: Function,
            required: true,
        },
        refresh: {
            type: Function,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: i18n.t('message.info.generalSearch'),
        },
        pagination: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },
        reduced: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            rowsPerPageItems: this.reduced ? [5] : constants.componentOptions.rowsPerPageItems,
            searching: false,
            loading: false,
            customPagination: {
                descending: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
    },

    computed: {
        // I'm a bad bad boy, I use setters with computed properties. Don't do that 'just because'.
        // If you want to do the same, read the documentation first so that you understand how it
        // works and think thrice about why you think you need it.
        filter: {
            get() {
                return this.$store.getters.searchFilter;
            },
            set(value) {
                this.$store.dispatch('setSearchFilter', value);
            },
        },
        filterPlaceholder() {
            if (!utilities.isEmpty(this.filter)) return this.filter;

            return this.placeholder;
        },
        items() {
            return this.search(this.filter);
        },
    },

    beforeCreate() {
        const route = this.$store.getters.route;

        // If the user is coming from the edit version of the current page, clear the filter
        if (route.from.name) {
            const entity = route.from.name.replace('Edit', '');
            if (route.to.name !== `${entity}Index`) this.$store.dispatch('clearSearchFilter');
        }
    },

    methods: {
        openSearch() {
            this.searching = true;
        },
        closeSearch() {
            this.searching = false;
        },
        cancelSearch() {
            this.filter = '';
            this.searching = false;
        },
        async reload() {
            if (this.loader) return;

            this.loading = true;
            await this.refresh();
            this.loading = false;
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/shared/SercheableDataTable.vue